module.exports = (__webpack_require__(0))(149);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/widgets/PluginConfigBreadcrumbWidget.js from dll-reference girder_lib
// module id = 13
// module chunks = 0